import Backend from './backend';
import Loader from './resources/js-simple-loader/loader.js';
import { Box } from './resources/js-validation-notification/validation.functions.js';
import { isValidCPF, isValidEmail, isValidTelefone, onlyDigits } from './utils/validation';
import {
    Activity,
    AppData,
    CreateEnrollMemberInSchedule,
    IScheduleResponse,
    Location,
    Member,
    Modality,
    Prospect,
    RentalContract,
    SaleData,
} from './types/types';

const modalidades: Modality[] = [
    {
        nome: 'Beach Tennis',
        alternate: 'BEACH TENNIS',
        image: 'http://posto011.com.br/wp-content/uploads/2025/08/agendamento-beach-tenis.jpg',
    },
    {
        nome: 'Futevôlei',
        alternate: 'FUTEVOLEI',
        image: 'http://posto011.com.br/wp-content/uploads/2025/08/agendamento-futvolei.jpg',
    },
    {
        nome: 'Vôlei de Praia',
        alternate: 'VOLEI',
        image: 'http://posto011.com.br/wp-content/uploads/2025/08/agendamento-volei.jpg',
    },
];

// Ordem de exibicao das regioes no select. Regioes fora desta lista aparecem
// depois, em ordem alfabetica, em vez de sumirem da tela.
const ordemDasRegioes: string[] = ['São Paulo Capital', 'Grande São Paulo', 'Interior de São Paulo'];

const IS_DEBUG_MODE = false;

function debugLog(...args: unknown[]): void {
    if (IS_DEBUG_MODE) {
        console.log(...args);
    }
}

let timesPassed: string[] = [];

export const Service = {
    branch: IS_DEBUG_MODE
        ? 'LINK TREINAMENTO'
              .normalize('NFD')
              .replace(/[\u0300-\u036f]/g, '')
              .toUpperCase()
        : (null as string | null),
    locations: [] as Location[],
    locationsRequest: null as Promise<Location[]> | null,
    googleMapsAPIKey: 'AIzaSyB2sPFpXnUcjZ3gdXuHrCFhoD50nZtGa3w',
    userHasSubmitted: (): AppData | false => {
        if (/enrollScheduled/.test(document.cookie)) {
            return JSON.parse(Service.getCookie('enrollScheduled') as string) as AppData;
        }
        return false;
    },
    setCookie: function (name: string, value: string, date: string) {
        let expires = '';
        expires = '; expires=' + new Date(date).toUTCString();
        document.cookie = name + '=' + (value || '') + expires + '; path=/';
    },
    getCookie: function (name: string): string | null {
        let nameEQ = name + '=';
        let ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    },
    validate: (data: AppData): AppData | false => {
        let lock = false;
        // const requiredKeys = ['nome', 'email', 'cpf', 'modalidade', 'telefone', 'unidade'] as const;
        const requiredKeys = ['nome', 'email', 'cpf', 'telefone', 'unidade'] as const;
        type RequiredKey = (typeof requiredKeys)[number];
        requiredKeys.forEach((req: RequiredKey) => {
            if (typeof data[req] === 'undefined') {
                debugLog('Não informado: ' + req);
                lock = true;
            }
        });
        if (lock) {
            debugLog(data);
            return false;
        }

        lock = !data.nome!.includes(' ');
        if (!isValidTelefone(data.telefone!)) {
            lock = true;
        }
        data.telefone = onlyDigits(data.telefone!);
        if (!isValidCPF(data.cpf!)) {
            lock = true;
        }
        data.cpf = onlyDigits(data.cpf!);
        if (!isValidEmail(data.email!)) {
            lock = true;
        }
        data.email = data.email!.trim();
        if (lock) {
            return false;
        }

        let nome = data.nome.split(' ');
        data.userData = {
            name: data.nome!.replace(nome[nome.length - 1], '').toUpperCase(),
            email: data.email!,
            cellphone: onlyDigits(data.telefone!),
            lastName: nome[nome.length - 1],
            cpf: onlyDigits(data.cpf!),
        };

        return data;
    },
    setBranch: (branch: string) => {
        if (IS_DEBUG_MODE) {
            Service.branch = 'LINK TREINAMENTO'
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .toUpperCase();
        } else {
            Service.branch = branch
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .toUpperCase();
        }
    },
    setCalendarTime: (event: Activity, array: string[]): { start: Date; end: Date } => {
        const offsets = ['00', '12', '24', '36', '48'];
        for (let i = 0; i < offsets.length; i++) {
            let aux = event.startTime.split(':');
            aux[1] = offsets[i];
            let stringStart = event.activityDate.split('T')[0] + 'T' + aux.join(':') + ':00';
            if (!array.includes(stringStart)) {
                array.push(stringStart);
                return {
                    start: new Date(stringStart),
                    end: new Date(new Date(stringStart).getTime() + 12 * 60000),
                };
            }
        }
        let stringStart = event.activityDate.split('T')[0] + 'T' + event.startTime + ':00';
        return {
            start: new Date(stringStart),
            end: new Date(new Date(stringStart).getTime() + 12 * 60000),
        };
    },
    filterActivities: (activities: Activity[]): Activity[] => {
        activities = activities.map((activity) => {
            activity.startString = activity.startTime.split(':').join('h') + ' ' + activity.activityDate.split('T')[0].split('-').reverse().join('/');
            return { ...activity, title: activity.name, refer: activity.name };
        });
        activities = activities.filter((activity) => typeof activity.refer !== 'undefined');

        let dateNow = new Date();
        dateNow.setTime(dateNow.getTime() + 1000 * 60 * 60 * 4);

        activities = activities.map((activity) => {
            let calendarTime = Service.setCalendarTime(activity, timesPassed);
            activity.start = calendarTime.start;
            activity.end = calendarTime.end;

            // if (activity.start && activity.start.getTime() <= dateNow.getTime()) {
            //     activity.title = 'Quadra alugada';
            // }

            if (
                activity.status >= 6 ||
                activity.ocupation === null ||
                activity.capacity === null ||
                (activity.ocupation !== null && activity.capacity !== null && activity.ocupation === activity.capacity)
            ) {
                activity.title = 'Quadra alugada';
            }
            // if (!activity.hasOwnProperty("idActivity")) {
            //     activity.title = "Quadra alugada"
            // }

            return activity;
        });
        return activities;
    },
    getActivities: async (idModalities: number[], customDate: boolean = false): Promise<Activity[]> => {
        debugLog('getActivities', Service.branch, !Service.branch);
        if (!Service.branch) {
            return [];
        }
        Loader.open();

        timesPassed = [];
        let activities = await Backend.call<Activity[] | string>(
            '/?path=/activities/schedule?showFullWeek=true&idActivities=' + idModalities.join(',') + '&branch=' + encodeURIComponent(Service.branch!),
        );

        if (activities === '') {
            return Service.getActivities(idModalities);
        }

        let today = new Date();
        if (today.getDay() === 0) {
            Loader.close();
            return Service.filterActivities(activities as Activity[]);
        }

        let daysToAdd = 7 - today.getDay();
        let sunday = new Date();
        sunday.setDate(today.getDate() + daysToAdd);
        let nextActivities = await Backend.call<Activity[]>(
            '/?path=/activities/schedule?showFullWeek=true&date=' +
                sunday.toLocaleDateString().split('/').reverse().join('-') +
                '&idActivities=' +
                idModalities.join(',') +
                '&branch=' +
                encodeURIComponent(Service.branch!),
        );
        let nextDates: string[] = [];
        for (let i = 0; i < today.getDay(); i++) {
            let d = new Date();
            d.setDate(sunday.getDate() + i);
            nextDates.push(d.toLocaleDateString().split('/').reverse().join('-'));
        }
        nextActivities = nextActivities.filter((na: Activity) => {
            let nad = na.activityDate.split('T')[0];
            return nextDates.includes(nad);
        });
        Loader.close();
        const activitiesAccumulated = [...(Array.isArray(activities) ? activities : []), ...(Array.isArray(nextActivities) ? nextActivities : [])];
        return Service.filterActivities(activitiesAccumulated);
    },
    getMember: async (data: AppData): Promise<Member[]> => {
        Loader.open();
        let user = await Backend.call<Member[]>(
            '/?path=/v2/members?email=' + data.email + '&document=' + onlyDigits(data.cpf ?? '') + '&branch=' + Service.branch,
        );
        if (!!user && user.length > 0) {
            let memberships = await Backend.call<any[]>(
                '/?path=/v3/membermembership?idMember=' + user.at(0).idMember + '&statusMemberMembership=1&branch=' + Service.branch,
            );
            if (memberships && memberships.length > 0) {
                // A venda da locacao cria um contrato para a pessoa. Esses contratos nao
                // podem contar como "e aluno", senao quem alugou uma vez passaria a pagar
                // o preco de aluno na proxima locacao.
                const idsDeLocacao = Service.getRentalMembershipIds();
                const contrato = memberships.find((m) => Number(m.statusMemberMembership) === 1 && !idsDeLocacao.includes(Number(m.idMembership)));
                if (contrato) {
                    user[0].idMembership = contrato.idMembership;
                }
            }
        }
        Loader.close();
        return user;
    },
    getProspect: async (data: AppData): Promise<Prospect[]> => {
        Loader.open();
        let user = await Backend.call<Prospect[]>('/?path=/prospects?email=' + data.email + '&branch=' + Service.branch);
        if (!user || user.length === 0) {
            user = await Backend.call<Prospect[]>('/?path=/prospects?document=' + onlyDigits(data.cpf ?? '') + '&branch=' + Service.branch);
        }
        Loader.close();
        return user;
    },
    scheduleClass: async (data: AppData): Promise<AppData | false> => {
        Loader.open();

        debugLog('SCHEDULE CLASS ======');
        debugLog(data);

        const user = data.user![0];
        const activities = data.activities ?? [];
        let scheduleClass: IScheduleResponse | null = null;
        let lastActivity: Activity | undefined;

        for (const activity of activities) {
            lastActivity = activity;
            const body: CreateEnrollMemberInSchedule = {
                idConfiguration: activity.idConfiguration,
                activityDate: new Date(activity.activityDate).toLocaleDateString('sv'),
                idMember: 'idMember' in user ? (user as Member).idMember : undefined,
                idProspect: 'idProspect' in user ? (user as Prospect).idProspect : undefined,
            };

            // BOOK
            scheduleClass = await Backend.call<IScheduleResponse>('/?path=/v2/activities/booking&branch=' + Service.branch, {
                ...body,
                userData: data.userData,
                activity,
                user,
            });
            debugLog(scheduleClass);
            debugLog(typeof scheduleClass);
            if (scheduleClass === null || !scheduleClass.success) {
                break;
            }
        }

        if (scheduleClass !== null && scheduleClass.success) {
            data['sucesso'] = true;
            Loader.close();
            Box({
                title: 'Sucesso!',
                messages: 'Sua locação foi agendada!',
                buttons: { ok: 'Ok' },
                actions: { ok: (b) => b.close() },
            });
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ event: 'schedule-enroll', data: data });
            Service.setCookie('enrollScheduled', JSON.stringify(data), lastActivity!.activityDate);
            return data;
        }
        Loader.close();
        debugLog('Ops, tivemos um problema ao agendar sua locação...');
        debugLog(scheduleClass);
        const messages: Record<string, string> = {
            sessao: 'A presença já está confirmada ou não há mais vagas disponíveis.',
        };
        let contains = scheduleClass !== null && messages.hasOwnProperty(scheduleClass?.errors[0].key);
        let messageError = scheduleClass !== null && scheduleClass?.errors[0]?.value;
        Box({
            title: 'Ops...',
            messages: contains
                ? messages[scheduleClass.errors[0].key]
                : (messageError ?? 'Tivemos um problema ao marcar agendar sua locação scheduleClass.'),
            buttons: { ok: 'Ok' },
            actions: { ok: (b) => b.close() },
        });
        return false;
    },
    getRentalMaxSlots: (location?: Location): number => {
        const hours = location?.rental?.contracts?.map((c) => c.hours) ?? [];
        return hours.length > 0 ? Math.max(...hours) : 1;
    },
    // Ids de contrato usados pela locacao, em todas as unidades carregadas
    getRentalMembershipIds: (): number[] => {
        const ids: number[] = [];
        for (const location of Service.locations) {
            const rental = location.rental;
            if (!rental) {
                continue;
            }
            for (const contract of rental.contracts ?? []) {
                ids.push(Number(contract.member.id), Number(contract.notMember.id));
            }
        }
        return ids.filter((id) => Number.isFinite(id));
    },
    getRentalContract: (location?: Location, count: number = 1): Pick<RentalContract, 'member' | 'notMember'> | undefined => {
        const rental = location?.rental;
        if (!rental) {
            return undefined;
        }
        return rental.contracts?.find((c) => c.hours === count);
    },
    getGatewayConfig: async (): Promise<any> => {
        return Backend.call<any>('/?path=/configuration/gateway&branch=' + Service.branch);
    },
    getCardFlags: async (): Promise<any[]> => {
        return Backend.call<any[]>('/?path=/configuration/card-flags&branch=' + Service.branch);
    },
    getCardTranslations: async (): Promise<any> => {
        return Backend.call<any>('/?path=/configuration/card-translation&branch=' + Service.branch);
    },
    // getGatewayFormToken: async (data: AppData): Promise<{ formToken: string } | null> => {
    //     const firstUser = data.user?.[0];
    //     const idProspect = firstUser && !('idMember' in firstUser) ? (firstUser as Prospect).idProspect : undefined;
    //     const idCliente = firstUser && 'idMember' in firstUser ? (firstUser as Member).idMember : undefined;
    //     const params = new URLSearchParams();
    //     if (data.email) params.set('email', data.email);
    //     if (idProspect) params.set('idProspect', String(idProspect));
    //     if (idCliente) params.set('idCliente', String(idCliente));
    //     return Backend.call<{ formToken: string }>('/?path=/configuration/gateway-form-token&branch=' + Service.branch + '&' + params.toString());
    // },
    createSale: async (data: AppData): Promise<AppData> => {
        Loader.open();
        const firstUser = data.user![0];
        const location = data.location;
        const totalHours = data.activities?.length ?? 1;
        const rentalContract = Service.getRentalContract(location, totalHours);
        if (!rentalContract) {
            // A unidade nao tem faixa cadastrada para essa quantidade de horas
            debugLog('Sem contrato de locacao configurado para', totalHours, 'hora(s)');
            Loader.close();
            data.sale = {
                errors: [{ key: 'Contrato', value: 'Nao ha contrato de locacao configurado para ' + totalHours + ' hora(s).' }],
            } as unknown as SaleData;
            return data;
        }
        const chosen = !!firstUser.idMembership ? rentalContract.member : rentalContract.notMember;
        // Cada faixa de horas e um contrato proprio no EVO, com a quantidade de sessoes
        // configurada nele: 1 contrato de N sessoes = N reservas com uma unica cobranca.
        // O valor vem do cadastro do contrato, por isso nao se envia membershipValue.
        const body: any = {
            idBranchToken: Service.branch,
            payment: data.payment ?? 1,
            totalInstallments: data.totalInstallments ?? 0,
            idMembership: Number(chosen.id),
            memberData: {
                document: onlyDigits(firstUser?.document ?? data.userData.cpf ?? '') || undefined,
            },
        };

        if (data.cardData) body.cardData = data.cardData;
        if ('idMember' in firstUser && !!firstUser.idMember) {
            body.memberData = {
                ...body.memberData,
                idMember: (firstUser as Member).idMember,
            };
        } else {
            body.idProspect = (firstUser as Prospect).idProspect;
        }
        debugLog({ body });
        data.sale = await Backend.call<SaleData>('/?path=/v2/sales&branch=' + Service.branch, body);
        Loader.close();
        return data;
    },
    addSale: async (data: AppData): Promise<AppData | false> => {
        let validated = Service.validate(data);
        debugLog({ validated });

        if (validated) {
            let user = await Service.addUser(data);
            debugLog({ user });
            if (!user) {
                return false;
            }

            const { sale } = await Service.createSale(user);
            debugLog({ sale });
            if (sale !== null && typeof sale === 'object' && !sale.hasOwnProperty('errors')) {
                let schedule = await Service.scheduleClass({
                    ...data,
                    ...user,
                    user: [
                        {
                            ...user.user.at(0),
                            idMember: sale.idCliente ?? sale.cliente.idCliente,
                        } as Member,
                    ],
                    sale,
                });

                if (schedule !== null && typeof schedule === 'object' && !schedule.hasOwnProperty('errors')) {
                    validated.sucesso = true;
                    return validated;
                }
            }

            return false;
        }

        return false;
    },
    addUser: async (data: AppData): Promise<AppData | false> => {
        let validated = { ...data };
        debugLog(validated);

        if (validated) {
            let member = await Service.getMember(validated);
            if (member.length > 0) {
                Loader.close();
                validated.user = member;
                return validated;
            }

            let user = await Service.getProspect(validated);
            if (user.length > 0) {
                validated.user = user;
                return validated;
            }

            let nome = validated.nome!.split(' ');
            if (user.length === 0) {
                Loader.open();
                const created = await Backend.call<Prospect | Prospect[]>('/?path=/prospects&branch=' + Service.branch, {
                    name: validated.nome!.replace(nome[nome.length - 1], '').toUpperCase(),
                    email: validated.email,
                    cellphone: onlyDigits(validated.telefone ?? ''),
                    lastName: nome[nome.length - 1].toUpperCase(),
                    cpf: onlyDigits(validated.cpf ?? ''),
                    tokenGympass: validated.tokenGympass || null,
                });
                if (created !== undefined) {
                    if (!Array.isArray(created) && 'idProspect' in created) {
                        validated.user = [created];
                        Loader.close();
                        return validated;
                    } else if (Array.isArray(created) && created.length > 0) {
                        if ('idProspect' in created.at(0)) {
                            validated.user = created;
                            Loader.close();
                            return validated;
                        }
                    }
                }
            }

            return false;
        }
        return false;
    },
    loadLocations: async (): Promise<Location[]> => {
        if (Service.locations.length > 0) {
            return Service.locations;
        }

        if (Service.locationsRequest) {
            return Service.locationsRequest;
        }

        Service.locationsRequest = Backend.call<Location[]>('/?path=get-unidades&branch=CIDADES')
            .then((response) => {
                if (!Array.isArray(response)) {
                    return [];
                }
                Service.locations = response.map((location) => ({
                    ...location,
                    rental: !IS_DEBUG_MODE
                        ? location.rental
                        : {
                              idActivity: 1289,
                              contracts: [
                                  {
                                      hours: 1,
                                      member: {
                                          id: 435,
                                          value: 'R$ 100,00',
                                      },
                                      notMember: {
                                          id: 436,
                                          value: 'R$ 150,00',
                                      },
                                  },
                              ],
                          },
                }));
                return Service.locations;
            })
            .finally(() => {
                // libera para nova tentativa caso a requisicao tenha falhado
                Service.locationsRequest = null;
            });
        return Service.locationsRequest;
    },
    getLocations: (): Location[] => {
        return Service.locations;
    },
    getRegions: (): string[] => {
        const regioes = Array.from(new Set(Service.locations.map((location) => location.regiao).filter((regiao) => !!regiao)));
        return regioes.sort((a, b) => {
            const ia = ordemDasRegioes.indexOf(a);
            const ib = ordemDasRegioes.indexOf(b);
            if (ia === -1 && ib === -1) {
                return a.localeCompare(b, 'pt-BR');
            }
            if (ia === -1) {
                return 1;
            }
            if (ib === -1) {
                return -1;
            }
            return ia - ib;
        });
    },
    getModalities: (): Modality[] => {
        return modalidades;
    },
    getParams: (): string[] | false => {
        let parameterList = new URLSearchParams(window.location.search);
        if (parameterList.size > 0 && parameterList.get('regiao')) {
            let params = parameterList.get('regiao')!;
            return params.split(',');
        }
        return false;
    },
    getSource: (): string | null => {
        let parameterList = new URLSearchParams(window.location.search);
        if (parameterList.size > 0) {
            return parameterList.get('source');
        }
        return null;
    },
};

void Service.loadLocations();
